(() => {
  if (window.vertexaCinematicHome) return;
  window.vertexaCinematicHome = true;
  if (!document.body.classList.contains('template-index')) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const compact = matchMedia('(max-width:989px)');
  const chrome = document.querySelector('[data-vtx-header-root]');
  const records = new Map();
  let frame = 0;
  let needsMeasure = true;
  let viewportHeight = innerHeight;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const record = records.get(entry.target);
      if (!record) return;
      record.active = entry.isIntersecting;
      const moving = !reduced.matches && (!compact.matches || record.kind === 'hero');
      record.target.style.willChange = record.active && moving ? 'transform' : 'auto';
    });
    schedule();
  }, {rootMargin:'100px 0px',threshold:0}) : null;
  function measure() {
    const y = scrollY;
    viewportHeight = innerHeight;
    records.forEach(record => {
      const bounds = record.anchor.getBoundingClientRect();
      record.top = bounds.top + y;
      record.height = bounds.height;
      record.amplitude = record.kind === 'factory' ? Math.min(36, bounds.height * .065) : record.kind === 'oem' ? 24 : 16;
    });
    needsMeasure = false;
  }
  function render() {
    frame = 0;
    if (document.hidden) return;
    if (needsMeasure) measure();
    const y = scrollY;
    chrome?.classList.toggle('is-home-scrolled', y > 48);
    if (reduced.matches) return;
    records.forEach(record => {
      if (!record.active) return;
      const compactView = compact.matches;
      if (compactView && record.kind !== 'hero') return;
      let offset;
      if (record.kind === 'hero') {
        const limit = Math.min(compactView ? 30 : 112, record.height * (compactView ? .04 : .12));
        offset = clamp((y - record.top) * (compactView ? .04 : .115), 0, limit);
        if (record.anchor.matches('.is-finder-result')) offset = 0;
      } else {
        const progress = clamp((viewportHeight - record.top + y) / (viewportHeight + record.height), 0, 1);
        offset = (progress - .5) * 2 * record.amplitude;
      }
      record.target.style.setProperty('--vtx-parallax-y', offset.toFixed(2) + 'px');
    });
  }
  function schedule(measureAgain = false) {
    if (measureAgain === true) needsMeasure = true;
    if (!document.hidden && !frame) frame = requestAnimationFrame(render);
  }
  function bind(root = document) {
    const add = (anchor, target, kind) => {
      if (!anchor || !target || records.has(anchor)) return;
      target.dataset.vtxParallax = kind;
      records.set(anchor, {anchor,target,kind,active:!observer,top:0,height:0,amplitude:0});
      observer?.observe(anchor);
    };
    root.querySelectorAll('.vtx-hero').forEach(anchor => add(anchor, anchor.querySelector('.vtx-hero__media img'), 'hero'));
    root.querySelectorAll('.vtx-pdf-feature').forEach(anchor => add(anchor, anchor.querySelector('.vtx-pdf-feature__media'), 'detail'));
    root.querySelectorAll('.vtx-pdf-proof .vtx-pdf-split__media, .vx-factory-story__photo').forEach(anchor => add(anchor, anchor.querySelector('img'), 'factory'));
    root.querySelectorAll('.vtx-pdf-oem').forEach(anchor => add(anchor, anchor.querySelector('.vtx-pdf-split__media'), 'oem'));
    root.querySelectorAll('.vtx-home img,.vtx-pdf-section img').forEach(image => {
      if (!image.complete) image.addEventListener('load', () => schedule(true), {once:true});
    });
    schedule(true);
  }
  function refreshPreference() {
    document.body.classList.toggle('is-home-parallax', !reduced.matches);
    records.forEach(record => {
      record.target.style.removeProperty('--vtx-parallax-y');
      record.target.style.willChange = 'auto';
    });
    schedule(true);
  }
  bind();
  refreshPreference();
  window.addEventListener('scroll', () => schedule(), {passive:true});
  window.addEventListener('resize', () => schedule(true), {passive:true});
  window.addEventListener('pageshow', () => schedule(true));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(frame);
      frame = 0;
      records.forEach(record => { record.target.style.willChange = 'auto'; });
    } else schedule(true);
  });
  document.addEventListener('toggle', () => schedule(true), true);
  reduced.addEventListener('change', refreshPreference);
  compact.addEventListener('change', refreshPreference);
  if ('ResizeObserver' in window) {
    const layoutObserver = new ResizeObserver(() => schedule(true));
    const main = document.getElementById('MainContent');
    if (main) layoutObserver.observe(main);
  }
  document.fonts?.ready.then(() => schedule(true));
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:section:unload', event => {
    records.forEach((record, anchor) => {
      if (!event.target.contains(anchor)) return;
      observer?.unobserve(anchor);
      record.target.style.removeProperty('--vtx-parallax-y');
      record.target.style.removeProperty('will-change');
      delete record.target.dataset.vtxParallax;
      records.delete(anchor);
    });
    schedule(true);
  });
})();


